import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import OtpInput from 'react-otp-input';
import CommonButton from '../Components/CommonButton';
import CommonInput from '../Components/CommonInput';
import { reset_password, send_otp, sign_up, verify_otp_reset } from '../services';
import ButtonLoader from '../Components/ButtonLoader';
import { useLocation } from "react-router-dom";

function ValidateOtp() {
    const navigate = useNavigate();
    const [otp, setOtp] = useState('');
    const [otpError, setOtpError] = useState('');
    const [isVerify, setVerify] = useState(false);
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [errors, setErrors] = useState({ password: '', confirm: '' });
    const [strength, setStrength] = useState(0);
    const [responseMsg, setResponseMsg] = useState('')
    const [resMsg, setResMsg] = useState('');
    const [errResMsg, setErrResMsg] = useState('');
    const [isResetFlow, setIsResetFlow] = useState(false);
    const [emailId, setEmailId] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showPass, setShowPass] = useState(false);
    const [showConfirmPass, setShowConfirmPass] = useState(false)
    const [showResend, setShowResend] = useState(true);
    const [timer, setTimer] = useState(30);
    const [getUserDataEmail, setGetUserDataEmail] = useState();
    const location = useLocation();

    useEffect(() => {
        // Track the previous route
        let prevPath = location.pathname;

        const unlisten = () => {
            window.addEventListener("popstate", () => {
                const currentPath = window.location.pathname;
                // If user goes back from OTP page to sign-up
                if (prevPath.includes("/otp-verification") && currentPath.includes("/sign-up")) {
                    alert(
                        "CONFIRM FORM RESUBMISSION \n\n" +
                        "The page that you're looking for used information that you entered. " +
                        "Returning to that page might cause any action you took to be repeated.\n\n"
                    );
                }
                prevPath = currentPath; // update previous path
            });
        };

        unlisten();

        return () => {
            window.removeEventListener("popstate", unlisten);
        };
    }, [location]);

    const validateOtp = () => {
        if (!otp.trim()) {
            setOtpError('OTP is required');
            setIsLoading(false);
            return false;
        }
        setOtpError('');
        return true;
    };

    const validatePassword = () => {
        let passwordError = '';
        let confirmError = '';
        const passwordRegex =
            /^(?=.{8,}$)(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()]).*$/;

        if (!password) {
            passwordError = 'Password is required';
            setIsLoading(false);
        } else if (!passwordRegex.test(password)) {
            passwordError =
                'Password must be ≥10 chars and include lowercase, uppercase, number & special char';
            setIsLoading(false);
        }

        if (!confirmPassword) {
            confirmError = 'Please confirm your password';
            setIsLoading(false);
        } else if (confirmPassword !== password) {
            confirmError = 'Passwords do not match';
            setIsLoading(false);
        }
        setErrors({ password: passwordError, confirm: confirmError });
        return !passwordError && !confirmError;
    };

    const onChangeHandler = (e) => {
        const { name, value } = e.target;
        const setters = {
            password: setPassword,
            confirmPassword: setConfirmPassword,
        };
        if (setters[name]) {
            setters[name](value);
            setErrResMsg('')
        }
        if (name === 'password') {
            setStrength(calculateStrength(value));
            setErrResMsg('')
        }
    };

    const calculateStrength = (password) => {
        let strength = 0;
        if (password.length >= 10) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/\d/.test(password)) strength++;
        if (/[!@#$%^&*()]/.test(password)) strength++;
        return Math.min(strength, 4);
    };

    useEffect(() => {
        // Reset-flow email + flag are passed via router navigation state (ephemeral),
        // with a sessionStorage fallback so a page refresh on this screen still works.
        const stateEmail = location.state?.email;
        const stateIsReset = location.state?.isReset;
        const email = stateEmail || sessionStorage.getItem('otp_email') || '';
        const resetFlag = stateIsReset !== undefined
            ? String(stateIsReset) === 'true'
            : sessionStorage.getItem('is_reset') === 'true';
        // Persist to sessionStorage so the values survive a refresh of this page.
        if (stateEmail) sessionStorage.setItem('otp_email', stateEmail);
        if (stateIsReset !== undefined) sessionStorage.setItem('is_reset', String(stateIsReset));
        setEmailId(email);
        setIsResetFlow(resetFlag);
    }, [location.state]);

    useEffect(() => {
        const getUserEmail = JSON.parse(localStorage.getItem('user_data') || '{}');
        setGetUserDataEmail(getUserEmail?.emailId)
    }, [])


    useEffect(() => {
        let interval;
        if (showResend && timer > 0) {
            interval = window.setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setShowResend(false);
        }
        return () => {
            if (interval) {
                clearInterval(interval);
            }
        };
    }, [showResend, timer]);

    const handleOtpSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!validateOtp()) {
            setIsLoading(false);
            return;
        }

        try {
            if (!isResetFlow) {
                // ---------- SIGN UP FLOW ----------
                const rawData = JSON.parse(localStorage.getItem("user_data") || "{}");
                const payload = { ...rawData, otp_code: otp };

                const response = await sign_up(payload);
                const successData = response?.statusCode?.response_data;
                const errorMessage = response?.statusCode?.error?.message;

                if (successData?.message) {
                    const { message, data } = successData;
                    setResponseMsg(message);
                    sessionStorage.setItem("access_token", data?.access_token || "");
                    localStorage.removeItem("user_data");
                    localStorage.removeItem("step");
                    navigate("/");
                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setResponseMsg("");
                }
            } else {
                // ---------- RESET FLOW ----------
                const payload = {
                    emailId: emailId,
                    otp_type: isResetFlow ? 'PASSWORD_RESET' : 'EMAIL_VERIFICATION',
                    otp_code: otp,
                };

                const response = await verify_otp_reset(payload);
                const successMessage = response?.statusCode?.response_data?.message;
                const errorMessage = response?.errors?.message;

                if (successMessage) {
                    setResponseMsg(successMessage);
                    setErrResMsg("");
                    setShowResend(true);
                    sessionStorage.removeItem("is_reset");
                    setIsResetFlow(false);
                    setVerify(successMessage);
                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setResponseMsg("");
                }
            }
        } catch (err) {
            console.error("OTP submission failed:", err);
            setErrResMsg("Something went wrong. Please try again.");
        } finally {
            setIsLoading(false);
        }
    };

    const handlePasswordSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        if (validatePassword()) {
            try {
                const query = {
                    emailId: emailId,
                    password: password,
                    confirm_password: confirmPassword
                }
                const response = await reset_password(query);
                setIsLoading(false);
                const successMessage = response?.statusCode?.response_data?.data?.message;
                const errorMessage = response?.errors?.message;
                if (successMessage) {
                    setResMsg(successMessage);
                    setIsLoading(false);
                    setErrResMsg('');
                    sessionStorage.removeItem('otp_email');
                    sessionStorage.removeItem('is_reset');
                    navigate('/');

                } else if (errorMessage) {
                    setErrResMsg(errorMessage);
                    setIsLoading(false);
                    setResMsg('');
                }

            } catch (error) {
                console.log(error)
            }
        }
    };
    const resendOtp = async () => {
        setIsLoading(true);
        setShowResend(false);
        setTimer(30);
        const rawData = JSON.parse(localStorage.getItem('user_data') || '{}');
        try {
            const payload = {
                emailId: rawData.emailId || emailId,
                otp_type: isResetFlow ? 'PASSWORD_RESET' : 'EMAIL_VERIFICATION',
                otp_code: otp,
                phone_number: rawData.phone_number,
                country_code: rawData.country_code
            };
            const response = await send_otp(payload);
            setIsLoading(false);
            const successMessage = response?.statusCode?.response_data?.message;
            const errorMessage = response?.errors?.message;

            if (successMessage) {
                setResponseMsg(successMessage);
                setIsLoading(false);
                setErrResMsg('');
                setShowResend(true);
            } else if (errorMessage) {
                setErrResMsg(errorMessage);
                setIsLoading(false);
                setResponseMsg('');
            }
        } catch (error) {
            console.error("Error sending OTP:", error);
            setErrResMsg("Failed to resend OTP. Please try again.");
            setIsLoading(false);
        }
    }

    return (
        <div className="sign-in-wrapper">
            {/* Left: Animated tagline */}
            <div className="signin-left-panel">
                <div className="signin-left-content">
                    <p className="animated-tagline-novaai">NOVA AI</p>
                    <p className="animated-tagline">Unified Cyber Risk Intelligence Platform</p>
                </div>
            </div>

            {/* Right: OTP / Change Password Form */}
            <div className="signin-form-panel">
                <div className="sign-in-wrper">
                    <div className="logo_wrper">
                        <img src="/assets/small_logo.svg" alt="Logo" width={300} height={90} />
                    </div>

                    {!isVerify ? (
                        <div className="card">
                            <h1 className="title">OTP Verification</h1>
                            <p className="auth_txt_color font_400 font_16">
                                Enter below the 6-digit code you received on <strong className="light_black"> {getUserDataEmail || emailId}</strong>
                            </p>

                            <form onSubmit={handleOtpSubmit} noValidate>
                                <div className="form-group">
                                    <div className="otp_inpt">
                                        <OtpInput
                                            value={otp}
                                            onChange={(value) => {
                                                setOtp(value);
                                                setOtpError('');
                                            }}
                                            numInputs={6}
                                            renderSeparator={<span>&nbsp;&nbsp;</span>}
                                            renderInput={(props) => <input {...props} />}
                                            inputStyle={{
                                                width: '40px',
                                                height: '40px',
                                                fontSize: '20px',
                                                fontWeight: '500',
                                                textAlign: 'center',
                                                border: '1px solid #E2E8F0',
                                                borderRadius: '6px',
                                                color: '#020617',
                                            }}
                                        />
                                    </div>
                                    {otpError && <p className="error-message">{otpError}</p>}
                                    <div className="d-flex-end">
                                        {showResend ?
                                            <p className="resend_otp_forget font_16">
                                                Resend OTP in {timer} seconds
                                            </p>
                                            : isLoading === true ?
                                                <p className="resend_otp_forget font_16">
                                                    Sending OTP
                                                </p>
                                                :
                                                <p
                                                    className="resend_otp_forget font_16"
                                                    onClick={resendOtp}
                                                >
                                                    Resend OTP
                                                </p>
                                        }
                                    </div>
                                </div>
                                {responseMsg && <p className="success-message">{responseMsg}</p>}
                                {errResMsg && <p className="error-message">{errResMsg}</p>}
                                <CommonButton type="submit" text="Verify" />
                            </form>

                            <p className="footer-text">
                                <button onClick={() => navigate("/")}>Back to Login</button>
                            </p>
                        </div>
                    ) : (
                        <div className="card">
                            <h1 className="title">Change Password</h1>
                            <form onSubmit={handlePasswordSubmit} noValidate>
                                <div className="form-group">
                                    <label htmlFor="password" className="font_500 font_16 light_black">Password</label>
                                    <CommonInput
                                        id="password"
                                        name="password"
                                        type={showPass ? 'text' : 'password'}
                                        value={password}
                                        onChange={onChangeHandler}
                                        placeholder="Type Strong Password"
                                        maxLength={30}
                                    />
                                    {errors.password && <p className="error-message">{errors.password}</p>}
                                    <span className="eye_icon">
                                        <img onClick={() => setShowPass(!showPass)} src={showPass ? "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/blind.svg" : "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/show.svg"}
                                            height={20}
                                            width={20}
                                            alt='eye'
                                        />
                                    </span>
                                </div>
                                <div className="strength-indicator">
                                    {Array.from({ length: 4 }).map((_, idx) => (
                                        <div
                                            key={idx}
                                            className={`bar ${idx < strength ? 'filled' : 'empty'}`}
                                        />
                                    ))}
                                </div>
                                <div className="form-group">
                                    <label htmlFor="confirm" className="font_500 font_16 light_black">
                                        Confirm New Password
                                    </label>
                                    <CommonInput
                                        id="confirm"
                                        name="confirmPassword"
                                        type={showConfirmPass ? 'text' : 'password'}
                                        value={confirmPassword}
                                        onChange={onChangeHandler}
                                        placeholder="Re-enter Password"
                                        maxLength={30}
                                    />
                                    {errors.confirm && <p className="error-message">{errors.confirm}</p>}
                                    <span className="eye_icon">
                                        <img onClick={() => setShowConfirmPass(!showConfirmPass)} src={showConfirmPass ? "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/blind.svg" : "https://nmtsecurity-publicbucket.s3.us-west-2.amazonaws.com/dashboard/show.svg"}
                                            height={20}
                                            width={20}
                                            alt='eye'
                                        />
                                    </span>
                                </div>
                                {resMsg && <p className="success-message">{resMsg}</p>}
                                {errResMsg && <p className="error-message">{errResMsg}</p>}
                                <CommonButton type="submit" text={isLoading ? <ButtonLoader /> : "Submit"} />
                            </form>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ValidateOtp;
